var map = {
	"./amex.png": 1029,
	"./diners.png": 1030,
	"./discover.png": 1031,
	"./jcb.png": 1032,
	"./maestro.png": 1262,
	"./mastercard.png": 1033,
	"./stripe.png": 1034,
	"./union.png": 1035,
	"./unknown.png": 713,
	"./visa.png": 1036
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1261;